// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"93cef760","453":"7dd570a6","681":"0a666dd5"}[chunkId] + ".chunk.js";
};